<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{ "title.general_category_uppercase" | translate }}</mat-card-title
    >
  </mat-card-header>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "title.search_condition" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form
          #f="ngForm"
          [formGroup]="searchCategoryForm"
          (ngSubmit)="onClickBtnFilter()"
          class="pb-3"
        >
          <div class="row">
            <div class="col-4">
              <!-- Ten danh muc -->
              <mat-form-field class="w-100">
                <input
                (focusout)="focusOut('nameContains')"
                  #focusInput
                  matInput
                  type="text"
                  [placeholder]="'general_category.category_name' | translate"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="nameContains"
                />
                <button
                  mat-button
                  *ngIf="searchCategoryForm?.controls?.nameContains?.value"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('nameContains')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- danh muc cha -->
              <mat-form-field class="w-100">
                <mat-select
                  id="status"
                  name="status"
                  formControlName="parentContains"
                  [placeholder]="'general_category.category_parent' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchParentCtrl"
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [searching]="loadingSearch"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let parent of listParentsFilter | async"
                    [value]="parent?.parentId"
                    >{{ parent?.parentName }}</mat-option
                  >
                </mat-select>
                <button
                  mat-button
                  *ngIf="searchCategoryForm?.controls?.parentContains?.value"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('parentContains')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- Ma/gia tri -->
              <mat-form-field class="w-100">
                <input
                (focusout)="focusOut('codeOrValueContains')"
                  matInput
                  type="text"
                  [placeholder]="'general_category.codeOrValue' | translate"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="codeOrValueContains"
                />
                <button
                  mat-button
                  *ngIf="
                    searchCategoryForm?.controls?.codeOrValueContains?.value
                  "
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('codeOrValueContains')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button mat-stroked-button color="primary" type="submit">
                <mat-icon class="mr-0" style="font-weight: 900"
                  >search</mat-icon
                >
                {{ "search_form.search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title
          class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center"
        >
          <span
            >{{ "title.search_result" | translate }} ({{
              paginate.totalRow
            }})</span
          >
          <button
            class="pull-right"
            mat-stroked-button
            color="primary"
            type="button"
            (click)="onClickCreateCategory()"
            [disabled]="commonService.getIsLockedEnterprise()"
          >
            <mat-icon class="mr-0">add_circle</mat-icon
            >{{ "button.add_category" | translate }}
          </button>
        </mat-panel-title>
        <div>
          <mat-table [dataSource]="listDataSource" matSort>
            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "headertable.stt" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ paginate.currentPage * paginate.pageSize + i + 1 }}
              </mat-cell>
            </ng-container>
            <!-- Tên danh mục -->
            <ng-container matColumnDef="name">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "headertable.category_type" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltip(element.name, i, 'nameDoc')"
                class="mat-cell-non-boder-right-bottom cell"
              >
                <span class="fix-width fw-100 nameDoc">{{ element.name }}</span>
              </mat-cell>
            </ng-container>
            <!-- Danh mục cha -->
            <ng-container matColumnDef="parent">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "headertable.category_parent" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltip(element.parentName, i, 'parentDoc')"
                class="mat-cell-non-boder-right-bottom"
              >
                <span class="fix-width fw-100 parentDoc">{{ element.parentName }}</span>
              </mat-cell>
            </ng-container>
            <!-- Mô tả -->
            <ng-container matColumnDef="description">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "headertable.description" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                [matTooltip]="displayTooltipForDes(element.description, i, 'descriptionDoc')"
                class="mat-cell-non-boder-right-bottom cellDes"
              >
              <span class="fix-width fw-100 descriptionDoc">{{ element.description }}</span>
              </mat-cell>
            </ng-container>
            <!-- Thao tác -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="text-center">
                {{ "headertable.action_header" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center">
                <button
                  mat-icon-button
                  type="button"
                  (click)="editCategory(element.id)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <mat-icon
                    matTooltip="{{
                      'document_template.tooltip_edit' | translate
                    }}"
                    >mode_edit</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="deleteCategory(element)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <i
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    class="fa fa-trash"
                    style="font-size: 20px"
                    aria-hidden="true"
                    matTooltip="{{
                      'document_template.tooltip_delete' | translate
                    }}"
                  ></i>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="element-row"
            >
            </mat-row>
          </mat-table>

          <!-- Pagination -->
          <app-pagination
            [(paginate)]="paginate"
            (pageChange)="onPageChange($event.page, $event.pageSize)"
          >
          </app-pagination>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
